// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prices{display:flex;flex-direction:column;gap:2px}.prices__item{white-space:nowrap}.prices__item--secondary:not(:only-child){color:var(--gray--200)}.prices__item__title{font-size:.875rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
